import { Pencil, Trash2 } from "lucide-react";
import MiniSparkline from "../miniSparkline";
import Tag from "../tag";
import * as S from "../dashboard/_shared";
import "./style.scss";

export default function AcaoCard({ a, sel, onSel, onEdit, onDel }) {
    const { SC, PC, pctChk, diasRest, C, fmtDt } = S;
    const sc = SC[a.status] || SC.pendente;
    const pc = PC[a.prio] || PC.media;
    const pr = pctChk(a.check);
    const d = diasRest(a.prazo);
    const isCes = a.tipo === "ces";
    return (
        <div
            className={`compAcaoCard${sel ? " is-selected" : ""}`}
            onClick={() => onSel(sel ? null : a.id)}
            style={{
                "--sc-color": sc.color,
                "--sc-color-glow": `${sc.color}15`,
                "--pr-pct": `${pr}%`,
                "--pr-bg": pr >= 100 ? "var(--color-green)" : "var(--color-g700)",
                "--pr-pct-color": pr >= 100 ? "var(--color-green)" : "var(--color-text-3)",
                "--kpi-color": isCes ? "var(--color-blue)" : "var(--color-g700)",
                "--date-color": d < 0 ? "var(--color-red)" : d < 15 ? "var(--color-orange)" : "var(--color-text-4)",
                "--date-weight": d < 0 || d < 15 ? 600 : 400,
            }}
        >
            {/* Header */}
            <div className="header">
                <div className="headerLeft">
                    <div className="tags">
                        <Tag label={sc.label} color={sc.color} />
                        <Tag label={pc.label} color={pc.color} />
                        <Tag label={a.etapa} color={isCes ? C.blue : C.g700} />
                        <Tag label={a.resp} color={C.purple || "#7C68EE"} />
                        {a.sucesso && (
                            <Tag
                                label={`🏆 Sucesso +${a.sucesso.ganhoPp}pp`}
                                color={C.green}
                                bg={C.greenBg}
                            />
                        )}
                    </div>
                    <div className="title">{a.titulo}</div>
                </div>
                <div className="actions" onClick={(e) => e.stopPropagation()}>
                    <button className="actionBtn actionBtn--edit" onClick={() => onEdit(a)}>
                        <Pencil size={11} />
                    </button>
                    <button className="actionBtn actionBtn--delete" onClick={() => onDel(a.id)}>
                        <Trash2 size={11} />
                    </button>
                </div>
            </div>

            {/* Progress */}
            <div className="progress">
                <div className="progressHeader">
                    <span>
                        {a.check.filter((c) => c.f).length}/{a.check.length} tarefas
                    </span>
                    <span className="progressPct">{pr}%</span>
                </div>
                <div className="progressBar">
                    <div className="progressFill" />
                </div>
            </div>

            {/* Footer */}
            <div className="footer">
                <MiniSparkline med={a.med} meta={a.v_meta} tipo={a.tipo} />
                <div className="meta">
                    <div className="metaKpi">
                        {isCes ? "CES" : "CSAT"}: <b>{a.v_atual}%</b> → <b>{a.v_meta}%</b>
                    </div>
                    <div className="metaDate">
                        {d < 0 ? `${Math.abs(d)}d atrasada` : `${d}d restantes`} ·{" "}
                        {fmtDt(a.prazo)}
                    </div>
                </div>
            </div>
        </div>
    );
}
